import { render } from "./ConfirmationDialog.vue?vue&type=template&id=3e5de70f&scoped=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js"

import "./ConfirmationDialog.vue?vue&type=style&index=0&id=3e5de70f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3e5de70f"

export default script